import { createGlobalStyle } from "styled-components";

export const Fonts = createGlobalStyle`
@font-face {
  font-family: dana;
  font-style: normal;
  font-weight: 10;
  src: url("assets/fonts/eot/dana-thin.eot");
  src: url("assets/fonts/eot/dana-thin.eot?#iefix") format("embedded-opentype"),
    /* IE6-8 */ url("assets/fonts/woff2/dana-thin.woff2") format("woff2"),
    /* FF39+,Chrome36+, Opera24+*/ url("assets/fonts/woff/dana-thin.woff")
      format("woff"); /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
}
@font-face {
  font-family: dana;
  font-style: normal;
  font-weight: 200;
  src: url("assets/fonts/eot/dana-extralight.eot");
  src: url("assets/fonts/eot/dana-extralight.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-8 */ url("assets/fonts/woff2/dana-extralight.woff2") format("woff2"),
    /* FF39+,Chrome36+, Opera24+*/ url("assets/fonts/woff/dana-extralight.woff")
      format("woff"); /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
}
@font-face {
  font-family: dana;
  font-style: normal;
  font-weight: 300;
  src: url("assets/fonts/eot/dana-light.eot");
  src: url("assets/fonts/eot/dana-light.eot?#iefix") format("embedded-opentype"),
    /* IE6-8 */ url("assets/fonts/woff2/dana-light.woff2") format("woff2"),
    /* FF39+,Chrome36+, Opera24+*/ url("assets/fonts/woff/dana-light.woff")
      format("woff"); /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
}
@font-face {
  font-family: dana;
  font-style: normal;
  font-weight: 500;
  src: url("assets/fonts/eot/dana-medium.eot");
  src: url("assets/fonts/eot/dana-medium.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-8 */ url("assets/fonts/woff2/dana-medium.woff2") format("woff2"),
    /* FF39+,Chrome36+, Opera24+*/ url("assets/fonts/woff/dana-medium.woff")
      format("woff"); /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
}
@font-face {
  font-family: dana;
  font-style: normal;
  font-weight: 600;
  src: url("assets/fonts/eot/dana-demibold.eot");
  src: url("assets/fonts/eot/dana-demibold.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-8 */ url("assets/fonts/woff2/dana-demibold.woff2") format("woff2"),
    /* FF39+,Chrome36+, Opera24+*/ url("assets/fonts/woff/dana-demibold.woff")
      format("woff"); /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
}
@font-face {
  font-family: dana;
  font-style: normal;
  font-weight: 750;
  src: url("assets/fonts/eot/dana-ultrabold.eot");
  src: url("assets/fonts/eot/dana-ultrabold.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-8 */ url("assets/fonts/woff2/dana-ultrabold.woff2") format("woff2"),
    /* FF39+,Chrome36+, Opera24+*/ url("assets/fonts/woff/dana-ultrabold.woff")
      format("woff"); /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
}
@font-face {
  font-family: dana;
  font-style: normal;
  font-weight: 800;
  src: url("assets/fonts/eot/dana-extrabold.eot");
  src: url("assets/fonts/eot/dana-extrabold.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-8 */ url("assets/fonts/woff2/dana-extrabold.woff2") format("woff2"),
    /* FF39+,Chrome36+, Opera24+*/ url("assets/fonts/woff/dana-extrabold.woff")
      format("woff"); /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
}
@font-face {
  font-family: dana;
  font-style: normal;
  font-weight: 900;
  src: url("assets/fonts/eot/dana-black.eot");
  src: url("assets/fonts/eot/dana-black.eot?#iefix") format("embedded-opentype"),
    /* IE6-8 */ url("assets/fonts/woff2/dana-black.woff2") format("woff2"),
    /* FF39+,Chrome36+, Opera24+*/ url("assets/fonts/woff/dana-black.woff")
      format("woff"); /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
}
@font-face {
  font-family: dana;
  font-style: normal;
  font-weight: bold;
  src: url("assets/fonts/eot/dana-bold.eot");
  src: url("assets/fonts/eot/dana-bold.eot?#iefix") format("embedded-opentype"),
    /* IE6-8 */ url("assets/fonts/woff2/dana-bold.woff2") format("woff2"),
    /* FF39+,Chrome36+, Opera24+*/ url("assets/fonts/woff/dana-bold.woff")
      format("woff"); /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
}
@font-face {
  font-family: dana;
  font-style: normal;
  font-weight: normal;
  src: url("assets/fonts/eot/dana-regular.eot");
  src: url("assets/fonts/eot/dana-regular.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-8 */ url("assets/fonts/woff2/dana-regular.woff2") format("woff2"),
    /* FF39+,Chrome36+, Opera24+*/ url("assets/fonts/woff/dana-regular.woff")
      format("woff"); /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
}

/**
Iranic assets/fonts	
**/

@font-face {
  font-family: dana;
  font-style: italic;
  font-weight: 10;
  src: url("assets/fonts/eot/dana-thinitalic.eot");
  src: url("assets/fonts/eot/dana-thinitalic.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-8 */ url("assets/fonts/woff2/dana-thinitalic.woff2") format("woff2"),
    /* FF39+,Chrome36+, Opera24+*/ url("assets/fonts/woff/dana-thinitalic.woff")
      format("woff"); /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
}
@font-face {
  font-family: dana;
  font-style: italic;
  font-weight: 200;
  src: url("assets/fonts/eot/dana-extralightitalic.eot");
  src: url("assets/fonts/eot/dana-extralightitalic.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-8 */ url("assets/fonts/woff2/dana-extralightitalic.woff2")
      format("woff2"),
    /* FF39+,Chrome36+, Opera24+*/
      url("assets/fonts/woff/dana-extralightitalic.woff") format("woff"); /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
}
@font-face {
  font-family: dana;
  font-style: italic;
  font-weight: 300;
  src: url("assets/fonts/eot/dana-lightitalic.eot");
  src: url("assets/fonts/eot/dana-lightitalic.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-8 */ url("assets/fonts/woff2/dana-lightitalic.woff2") format("woff2"),
    /* FF39+,Chrome36+, Opera24+*/
      url("assets/fonts/woff/dana-lightitalic.woff") format("woff"); /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
}
@font-face {
  font-family: dana;
  font-style: italic;
  font-weight: 500;
  src: url("assets/fonts/eot/dana-mediumitalic.eot");
  src: url("assets/fonts/eot/dana-mediumitalic.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-8 */ url("assets/fonts/woff2/dana-mediumitalic.woff2")
      format("woff2"),
    /* FF39+,Chrome36+, Opera24+*/
      url("assets/fonts/woff/dana-mediumitalic.woff") format("woff"); /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
}
@font-face {
  font-family: dana;
  font-style: italic;
  font-weight: 600;
  src: url("assets/fonts/eot/dana-demibolditalic.eot");
  src: url("assets/fonts/eot/dana-demibolditalic.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-8 */ url("assets/fonts/woff2/dana-demibolditalic.woff2")
      format("woff2"),
    /* FF39+,Chrome36+, Opera24+*/
      url("assets/fonts/woff/dana-demibolditalic.woff") format("woff"); /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
}
@font-face {
  font-family: dana;
  font-style: italic;
  font-weight: 750;
  src: url("assets/fonts/eot/dana-ultrabolditalic.eot");
  src: url("assets/fonts/eot/dana-ultrabolditalic.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-8 */ url("assets/fonts/woff2/dana-ultrabolditalic.woff2")
      format("woff2"),
    /* FF39+,Chrome36+, Opera24+*/
      url("assets/fonts/woff/dana-ultrabolditalic.woff") format("woff"); /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
}
@font-face {
  font-family: dana;
  font-style: italic;
  font-weight: 800;
  src: url("assets/fonts/eot/dana-extrabolditalic.eot");
  src: url("assets/fonts/eot/dana-extrabolditalic.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-8 */ url("assets/fonts/woff2/dana-extrabolditalic.woff2")
      format("woff2"),
    /* FF39+,Chrome36+, Opera24+*/
      url("assets/fonts/woff/dana-extrabolditalic.woff") format("woff"); /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
}
@font-face {
  font-family: dana;
  font-style: italic;
  font-weight: 900;
  src: url("assets/fonts/eot/dana-blackitalic.eot");
  src: url("assets/fonts/eot/dana-blackitalic.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-8 */ url("assets/fonts/woff2/dana-blackitalic.woff2") format("woff2"),
    /* FF39+,Chrome36+, Opera24+*/
      url("assets/fonts/woff/dana-blackitalic.woff") format("woff"); /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
}
@font-face {
  font-family: dana;
  font-style: italic;
  font-weight: bold;
  src: url("assets/fonts/eot/dana-bolditalic.eot");
  src: url("assets/fonts/eot/dana-bolditalic.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-8 */ url("assets/fonts/woff2/dana-bolditalic.woff2") format("woff2"),
    /* FF39+,Chrome36+, Opera24+*/ url("assets/fonts/woff/dana-bolditalic.woff")
      format("woff"); /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
}
@font-face {
  font-family: dana;
  font-style: italic;
  font-weight: normal;
  src: url("assets/fonts/eot/dana-regularitalic.eot");
  src: url("assets/fonts/eot/dana-regularitalic.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-8 */ url("assets/fonts/woff2/dana-regularitalic.woff2")
      format("woff2"),
    /* FF39+,Chrome36+, Opera24+*/
      url("assets/fonts/woff/dana-regularitalic.woff") format("woff"); /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
}
`;
